<div>
    <div class="row">
      <div class="col-5 mb-3">
        <h2 class="title-list">{{ title }}</h2>
      </div>
      <div class="col btn-back text-end">
        <button class="btn btn-secondary" (click)="goBack()">Back</button>
      </div>
    </div>
    <div class="fw-bold bg-white p-3 rounded-5 mb-5" *ngIf="permissionsService.createPermission">
      <!-- Primera fila -->
      <div class="row mt-3">
        <div class="col">
          <label for="information" class="labelInformation">{{
            information
            }}</label>
        </div>
      </div>
    
      <!-- Segunda fila -->
      <div class="row mt-3">
        <div class="col-6">
          <label for="customerName">Role Name<span class="required">*</span></label>
          <input type="text" class="form-control input-label" (input)="checkFields()" [disabled]="true" [(ngModel)]="roleName" />
        </div>
      </div>
    
    
      <!-- cuarta fila -->
      <div class="row mt-3">
        <div class="col">
          <input type="checkbox" class="checkbox" id="active" name="active" [(ngModel)]="isActive" [disabled]="true" />
          <label for="active" class="m-2">Active</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4 mb-3">
        <h2 class="title-list">Permissions List</h2>
      </div>
      <div class="col-4">
        <div class="input-group mb-3">
          <span class="input-group-text" id="basic-addon1">
            <i class="bi bi-search"></i>
          </span>
          <input
          type="text"
          class="form-control input-label"
          placeholder="Search"
          [(ngModel)]="textoBusqueda"
          (input)="onSearchChange()"
        />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-responsive rounded-5">
          <table class="table table-striped mb-0">
            <caption class="d-none">
              List of permissions and their details
            </caption>
            <thead class="head-table">
              <tr>
                <th class="px-4 py-3 align-middle">Name Module</th>
                <th class="px-4 py-3 align-middle">Create</th>
                <th class="px-4 py-3 align-middle">Read</th>
                <th class="px-4 py-3 align-middle">Edit</th>
                <th class="px-4 py-3 align-middle">Archive</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let moduleRole of listModuleByRole">
                <td class="px-4 py-3 align-middle" title="{{ moduleRole.nameModule }}">
                  {{ moduleRole.nameModule }}
                </td>
                <td class="px-4 py-3 align-middle">
                  <input type="checkbox" class="checkbox" [(ngModel)]="moduleRole.createPermission"
                    [disabled]="true">
                </td>
                <td class="px-4 py-3 align-middle" >
                  <input type="checkbox" class="checkbox" [(ngModel)]="moduleRole.readPermission"
                    [disabled]="true">
                </td>
                <td class="px-4 py-3 align-middle">
                  <input type="checkbox" class="checkbox" [(ngModel)]="moduleRole.editPermission"
                    [disabled]="true">
                </td>
                <td class="px-4 py-3 align-middle">
                  <input type="checkbox" class="checkbox" [(ngModel)]="moduleRole.archivePermission"
                    [disabled]="true">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>